import * as Yup from "yup";

export const initialValuesCheckbook = {
    amount: "",
    checkbook_comment: "",
    account_id: "",
    output: ""
}

export const validationSchemaCheckbook = Yup.object().shape({
    "account_id": Yup.number().required('Debe seleccionar la cuenta del cheque.'),
    "checkbook_comment": Yup.string().required('El comentario del cheque es requerido.'),
    "amount": Yup.number().required('El monto del cheque es necesario.'),
    "output": Yup.string().required('El tipo de salida del cheque es necesario.')
})